import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=4e20c9d3"
import script from "./ActivityInfo.vue?vue&type=script&lang=js"
export * from "./ActivityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports